
























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "stadium/vips";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", dataIndex: "user_name" },
    { title: "备注", dataIndex: "description" },
    { title: "会员名", dataIndex: "name" },
    { title: "会员卡号", dataIndex: "vip_code" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "加入时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
